console.log('custom.js entry');
window.hasLoaded = false;

window.addEventListener("load", () => {
  Init();
});

window.onpageshow = function(event) {
  console.log("ON PAGE SHOW", event, window.location.href);
    if (event.persisted && (window.location.href.endsWith('/cart') || window.location.href.endsWith('/cart/'))) {
        window.location.reload() 
    }
};

setTimeout(() => {
  if(window.hasLoaded) {
    console.log('window loaded complete');
  } else {
    console.log('window not loaded');
    Init();
  }
}, 1000);

function Init() {
  if (window.hasLoaded) return;
  window.hasLoaded = true;
  console.log('page loaded');
  window.doneScroll = false;
  SmileLauncherTriggers();
  ProductDescTabs();
  HeaderPadding();
  SubscriptionInfo();
  InfluencerHandling();
  //DiscountUpgrades();

  HelpCenterHandle();
  ConfigureSubAndSave();
  ConfigureRebuy();
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function ConfigureRebuy() {
  document.addEventListener('rebuy:cart.add', (event) => { setCookie("_rdeclinedgifts", "", 1); }); 
  document.addEventListener('rebuy:cart.change', (event) => { setCookie("_rdeclinedgifts", "", 1); }); 

}

function HelpCenterHandle() {
  if (window.location && window.location.href.indexOf('/help-center') > -1) {
    console.log('HANDLE HELP CENTER');
    // .banner-text.css-1379lmr.epkclfx0
    // font-family: IVY_THIN !important; ^^^^
    setTimeout(() => {
      $('#caym7tnl').contents().find(".banner-text.css-1379lmr.epkclfx0").css('font-family', 'IVY_THIN !important;');
    }, 2000);
  }
}

function SubscriptionInfo() {
  console.log('Add subscription info');
  var newInfo = `<li>
        <div class="skio-icon">
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" id="calendar"><path fill="#200E32" d="M0.00676782204,6.77232286 C-0.0494507818,5.65586163 0.245894841,4.55305045 0.84355309,3.62839007 L0.99923733,3.40103165 L1.01210426,3.38857175 L1.12018651,3.26174784 L1.12018651,3.26174784 L1.23341553,3.13225394 L1.24628246,3.11890406 C1.46244695,2.89729595 1.70177193,2.70238761 1.9599684,2.53595903 L2.03288103,2.48979068 L2.03288103,2.48979068 L2.10579365,2.44695979 L2.27735277,2.34817064 C2.34683422,2.31524092 2.42232023,2.27608125 2.49180167,2.24315153 C2.54241161,2.2235717 2.59302155,2.19776192 2.64363149,2.17818209 C2.73884681,2.13813243 2.84006669,2.09897277 2.94128657,2.06604305 C2.97559839,2.04913319 3.01162581,2.03578331 3.04851102,2.02688338 L3.08947076,2.01041852 L3.08947076,2.01041852 L3.13429058,1.99395366 C3.59578461,1.85600484 4.07014558,1.76077565 4.54965332,1.71716603 L4.5,1.72298326 L4.5,0.728345984 C4.5,0.329539814 4.82169259,0.00708167176 5.21955196,0.00708167176 C5.61741133,0.00708167176 5.94,0.329539814 5.94,0.728345984 L5.94,3.87208831 C5.94,4.27089448 5.61741133,4.59425084 5.21955196,4.59425084 C4.82169259,4.59425084 4.5,4.27089448 4.5,3.87208831 L4.50004747,3.14527577 C4.02769655,3.19256915 3.56389095,3.31009562 3.12399703,3.49626084 C1.98883322,4.00693847 1.44745054,4.97946655 1.39615018,6.52067306 L1.39210771,6.76876289 L1.39210771,7.15590959 L16.6085438,7.15590959 L16.6085438,6.75897298 C16.6377089,6.04519907 16.494457,5.33498514 16.1907974,4.69330061 C15.8991469,4.1441753 15.4325061,3.71786894 14.8689344,3.48647092 C14.5100327,3.33196824 14.1341124,3.22417236 13.7499572,3.16536166 L13.5,3.13498326 L13.5000297,3.86846142 C13.5000297,4.26554745 13.1778298,4.58716917 12.7800299,4.58716917 C12.38223,4.58716917 12.06003,4.26554745 12.06003,3.86846142 L12.06,3.08098326 L5.94700235,3.08152438 L5.94700235,1.65130659 L12.06,1.65098326 L12.06003,0.724115014 C12.05643,0.327028983 12.37683,0.00271211083 12.7746299,1.15491618e-13 C13.1724298,-0.00267819729 13.4973297,0.316248366 13.5000297,0.713334398 L13.500604,1.71745172 C13.8499757,1.75192359 14.19651,1.8128727 14.5375476,1.89995417 L14.8766545,1.99573365 C14.904104,2.0010736 14.9246911,2.00819354 14.9624341,2.02154343 C15.0001771,2.03489331 15.0319155,2.0482432 15.0696585,2.06070309 C15.1700206,2.09363281 15.2635203,2.13279248 15.3604513,2.17284213 C15.416208,2.19242197 15.4676757,2.21823175 15.5114233,2.23781158 C15.5869093,2.2707413 15.6641109,2.30990096 15.7258722,2.34283068 C15.7893491,2.3757604 15.8502525,2.41225009 15.9034359,2.44161984 C15.9566192,2.47098959 15.9977934,2.50391931 16.0423988,2.53061908 C16.2366895,2.65610801 16.42133,2.7976168 16.5937871,2.95326813 L16.7620893,3.1135641 L16.7698094,3.12691399 L16.8874346,3.25173542 L16.8874346,3.25173542 L16.9979831,3.3832318 L17.0039876,3.39569169 C17.6508975,4.29033944 17.9988681,5.37684638 17.9999972,6.49001176 L17.9930259,6.76876289 L17.9930259,7.15590959 L18,7.15590959 L18,14.9101539 C18,18.291571 16.111588,19.9999833 12.3690987,19.9999833 L12.3690987,19.9999833 L5.6223176,19.9999833 C1.88841202,19.9999833 0,18.291571 0,14.9101539 L0,14.9101539 L0,7.15590959 L0.00676782204,7.15590959 L0.00676782204,6.77232286 Z M13.1158798,14.2462631 C12.6523605,14.2462631 12.2832618,14.6268939 12.2832618,15.0960433 C12.2918455,15.5651928 12.6609442,15.9458235 13.1158798,15.9458235 C13.5708155,15.9458235 13.9399142,15.5651928 13.9399142,15.0960433 C13.9399142,14.6268939 13.5708155,14.2462631 13.1158798,14.2462631 L13.1158798,14.2462631 Z M9.00429185,14.2374113 C8.54077253,14.2462631 8.17167382,14.6268939 8.17167382,15.0960433 C8.17167382,15.5651928 8.54935622,15.9458235 9.00429185,15.9458235 C9.45922747,15.9458235 9.82832618,15.5651928 9.82832618,15.0871915 C9.81974249,14.6268939 9.45922747,14.2462631 9.00429185,14.2374113 L9.00429185,14.2374113 Z M4.88412017,14.2374113 C4.42060086,14.2374113 4.05150215,14.6268939 4.06008584,15.0960433 C4.06008584,15.5651928 4.42918455,15.9458235 4.88412017,15.9458235 C5.33905579,15.9458235 5.70815451,15.556341 5.70815451,15.0871915 C5.70815451,14.618042 5.33905579,14.2374113 4.88412017,14.2374113 Z M13.1158798,10.6169935 C12.6523605,10.6169935 12.2918455,10.9976242 12.2918455,11.4667737 C12.2918455,11.9359232 12.6609442,12.3165539 13.1158798,12.3165539 C13.5708155,12.3165539 13.9399142,11.9359232 13.9399142,11.4667737 C13.9399142,10.9976242 13.5708155,10.6169935 13.1158798,10.6169935 Z M9.00429185,10.6081417 C8.54077253,10.6169935 8.17167382,10.9976242 8.17167382,11.4667737 C8.17167382,11.9359232 8.54935622,12.3165539 9.00429185,12.3165539 C9.45922747,12.3165539 9.82832618,11.9359232 9.82832618,11.4579219 C9.82832618,10.9976242 9.45922747,10.6169935 9.00429185,10.6081417 L9.00429185,10.6081417 Z M4.89270386,10.6081417 C4.42918455,10.6081417 4.06008584,10.9976242 4.06008584,11.4667737 C4.06008584,11.9359232 4.42918455,12.3165539 4.88412017,12.3165539 C5.34763948,12.3165539 5.7167382,11.9270713 5.70815451,11.4579219 C5.70815451,10.9887724 5.33905579,10.6081417 4.89270386,10.6081417 L4.89270386,10.6081417 Z" transform="translate(3 2)"></path></svg>
        </div>
        
        <div class="skio-content">
          <p>Minimum Term</p>
          <small>Cancel after 2 purchase cycles</small>
        </div>
      </li>`;
  $('.skio-details .skio-details--content ul').append(newInfo);

  window.onclick = () => {
    $('details.skio-details[open]').attr('open', false)
}
}

function InfluencerHandling() {
  console.log("InfluencerHandling");
  if (window.location && window.location.hash == '#influencer-home') {
    setTimeout(() => {
      console.log('open influencer');
      window.dispatchEvent(new CustomEvent("openWidget"));
    }, 500)
    setTimeout(() => {
      console.log('open influencer');
      window.dispatchEvent(new CustomEvent("openWidget"));
    }, 1500)
  } else {
    console.log('NOT influencer', window.location.hash);
  }
}

function HeaderPadding() {
  $(window).on('resize', (event) => {
    setTimeout(() => {  
      //$('body').css('paddingTop', $('#site-control').height());
    }, 500);
  });
}

function FAQ_Close(event) {
  if (!event.isTrusted) return;
  //console.log(event);
  $('.cc-accordion-item.is-open .cc-accordion-item__title').click();
}

function DiscountUpgrades() {
  $("div.docapp-coupon-input--bean-container--bean-remove").on('click', (event) => {
    console.log(event);
    console.log($(event.target).attr('data-code'));
  })
}

function MicrosoftATCTracking(product) {
  console.log('gc-i.js:addItemToCartHandler->c.js:MicrosoftATCTracking', product);
	window.uetq = window.uetq || [];
	window.uetq.push('event', 'add_to_cart', { 
		'ecomm_prodid': [product.product_id], 
		'ecomm_pagetype': 'product',
		'ecomm_totalvalue': product.line_price,
		'revenue_value': product.line_price,
		'currency': 'GBP',
		'items': [ 
		    { 
		      'id': product.product_id, 
		      'quantity': product.quantity, 
		      'price': product.price 
		    }
		  ] 
		}
	);
}

function SkioOnChange() {
  $('.clickyboxes li a').on('click', (e) => {
    var variantName = $(e.target).text().trim();
    window.product.variants.forEach((v, i) => {
      if (v.title == variantName) {
        window.dispatchEvent( new CustomEvent("cc-variant-updated", { detail: { variant: v } }));  
      }
    });
  });
}

function ProductDescTabs() {
  console.log('product desc tabs');
  $('details.product').on('click', (ev) => {
    var el = $('details.product');
    for (var i = 0; i < el.length; i++) {
      if (el[i] != ev.currentTarget) {
        el[i].removeAttribute("open");
      }
    }
  })
}

function SmileLauncherTriggers() {
  
  var triggerEl = null;
  var __ = setInterval(() => {
    triggerEl = $('.smile-launcher-frame-container.smile-launcher-closed');
    if (triggerEl != null && triggerEl.length > 0)  {
      $('#smile-ui-lite-launcher-frame-container, #smile-ui-lite-container, #smile-ui-container .smile-launcher-closed').css({'z-index': '10', 'height': '0'});
      clearInterval(__);
      setTimeout(() => {
        if (window.location.href.indexOf('smile') == -1) { window.location.href = window.location.origin + window.location.pathname;} else {
          console.log('click?');
        }
      }, 100);
    } else {
        if (!window.doneScroll && window.location.href.indexOf('smile') > -1) {
          window.scrollTo(1, 0);
          document.body.scrollTo({
            top: 1,
            left: 0,
            behavior: "smooth",
          });
          window.doneScroll = true;
        }
    }
  }, 100);
}

function lsStickyTrigger(formId) {
  console.log('sticky ATC');
  $(`#${formId} button.js-go-cart-add-to-cart`).click();
}

function CalculateShipping(cartTotal) {
  return;
  setTimeout(() => {
        var bounds = [
             [0, 4000],
             [4000, 6000],
             [6000, 100000000],
        ];
        var boundMessages = [
             "Spend £{x} more to get free shipping.",
             "Spend another £{x} to get DPD next-day shipping",
             "Yes! - You’ve got DPD next-day shipping for free!"
        ];
        var curPrice = cartTotal;
        var boundIndex = -1;
        bounds.forEach((bound, index) => {
          if (boundIndex > -1) return;
          if (curPrice >= bound[0] && curPrice <= bound[1]) {
              boundIndex = index;
          }
        });
    var diff = ((bounds[boundIndex][1] - curPrice) / 100).toFixed(2);
    var message = boundMessages[boundIndex].replace('{x}', diff);
    setTimeout(() => {
      $('#cartShippingMessage').text(message);
    }, 100);
  }, 100);
}


function ConfigureSubAndSave() {
console.log('ConfigureSubAndSave');
  $('.selected_selling_plan').on('click', (e) => {
    console.log('toggle')
    var product_form_id = $(e.currentTarget).attr('data-form');
    // close others
    $(`.product-form:not(#${product_form_id}) .selling_plan_options`).addClass('closed');
    $(`.product-form:not(#${product_form_id}) .selected_selling_plan`).removeClass('open');

    //
    if ($(e.currentTarget).hasClass('open')) {
      $(e.currentTarget).removeClass('open');
      $(`#${product_form_id} .selling_plan_options`).addClass('closed');
    } else {
       $(e.currentTarget).addClass('open'); 
      $(`#${product_form_id} .selling_plan_options`).removeClass('closed');
    }
  });
}

function SellingPlanRender() {
  $('.selected_selling_plan').each((i, e) => {
    var productFormId = $(e).attr('data-form-id');
    var productCard = $(e).attr('data-for');
    var productId = $(e).attr('data-product');
    var variantId = $(e).attr('data-variant');

    // update selected html
    var updatingIndex = window._product_options[`${productFormId}`][`${productCard}`].findIndex((e, i) => e.product == productId && e.variant == variantId);
    if (updatingIndex >= 0) {
    var product = window._product_options[`${productFormId}`][`${productCard}`][updatingIndex]
    console.log(product);
    $(`#${productFormId}.product-form .selected_selling_plan`).html('');
    $(`#${productFormId}.product-form .selected_selling_plan`).append(product.html);


    $(`#${productFormId}.product-form .selling_plan_options`).html('');
    window._product_options[`${productFormId}`][`${productCard}`].forEach((e, i) => {
        if (i == updatingIndex) return;
        $(`#${productFormId}.product-form .selling_plan_options`).append(window._product_options[`${productFormId}`][`${productCard}`][i].html);
      });

     // update form
    $(`#${productFormId}.product-form input#selling_plan`).val(product.sellingPlanId);
    $(`#${productFormId}.product-form input#id`).val(product.variant);
    $(`#${productFormId}.product-form input#product-id`).val(product.product);
  }
  }); 
}

function SellingPlanChange(event) {
    if($(event).parent('.selected_selling_plan').length > 0) return; // already selected
  var productFormId = $(event).attr('data-form-id');
  var productCard = $(event).attr('data-for');
  var productId = $(event).attr('data-product');
  var variantId = $(event).attr('data-variant');

  // update selected html
  var updatingIndex = window._product_options[`${productFormId}`][`${productCard}`].findIndex((e, i) => e.product == productId && e.variant == variantId);
  if (updatingIndex >= 0) {
    var product = window._product_options[`${productFormId}`][`${productCard}`][updatingIndex]
    console.log(product);
    $('.soap_atc').show();
    $(`#${productFormId}.product-form .selected_selling_plan`).html('');
    $(`#${productFormId}.product-form .selected_selling_plan`).append(product.html);


    $(`#${productFormId}.product-form .selling_plan_options`).html('');
    window._product_options[`${productFormId}`][`${productCard}`].forEach((e, i) => {
        if (i == updatingIndex || !e.selectable) return;
        $(`#${productFormId}.product-form .selling_plan_options`).append(e.html);
      });

     // update form
    $(`#${productFormId}.product-form input#selling_plan`).val(product.sellingPlanId);
    $(`#${productFormId}.product-form input#id`).val(product.variant);
    $(`#${productFormId}.product-form input#product-id`).val(product.product);
  }

  // close toggle
  $(`#${productFormId}.product-form .selling_plan_options`).addClass('closed');
  $(`#${productFormId}.product-form .selected_selling_plan`).removeClass('open');
}
